import React, { FormEvent, ReactElement } from 'react';
import { Button, Heading } from 'idsk-react-components';
import './detailTerminuSectionHeading.scss';
import iconEdit from '../../../../assets/images/icon-edit-black.svg';
import addIcon from '../../../../assets/images/icon-plus-dark.svg';

interface Props {
  heading: string;
  admin?: boolean;
  marginTop?: boolean,
  onClick?: (e: FormEvent<HTMLButtonElement>) => void;
  terminListNotEmpty: boolean
}

const DetailTerminuSectionHeading = ({
  heading,
  admin = false,
  marginTop = true,
  onClick,
  terminListNotEmpty,
}: Props): ReactElement => (
  <div className={`detail-terminu-section-heading ${marginTop ? 'detail-terminu-section-heading-margin-top' : ''}`}>
    <Heading size="l" className="detail-terminu-section-heading-xl">{heading}</Heading>
    {admin && (
    <>
      {terminListNotEmpty ? (
        <Button
          buttonStyle="third"
          size="large"
          iconBefore={iconEdit}
          onClick={onClick}
        >
          Upraviť
        </Button>
      ) : (
        <Button
          buttonStyle="third"
          size="large"
          iconBefore={addIcon}
          onClick={onClick}
        >
          Pridať
        </Button>
      )}
    </>
    )}
  </div>
);
export default DetailTerminuSectionHeading;
